import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-base" }




export default /*@__PURE__*/_defineComponent({
  __name: 'MsgReplyMenu',
  emits: ["menuAction"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const action = (index: number) => {
  emits("menuAction", index);
};

return (_ctx: any,_cache: any) => {
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Refresh = _resolveComponent("Refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "复制",
      placement: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_icon, {
          color: `#888888`,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (action(0))),
          class: "icon",
          size: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CopyDocument)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "重新生成",
      placement: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_icon, {
          color: `#888888`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (action(1))),
          class: "icon",
          size: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Refresh)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})